import script from "./AgeRangeSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./AgeRangeSlider.vue?vue&type=script&setup=true&lang=js"

import "./AgeRangeSlider.vue?vue&type=style&index=0&id=61067f87&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61067f87"]])

export default __exports__